<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">BSAC Japan eラーニング利用規約</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <h4 class="page-content__article-section-title">第1条（規約の適用）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                本規約は、株式会社BSAC（以下「当社」という）が提供するBSAC Japan
                eラーニングサービスの各コースの利用を申込み、当社がその利用を承認した者（以下「受講者」という）が、当該eラーニングコースを受講する際に適用されます。<br />
                受講者は、eラーニングコースの受講（以下、「本サービス」という）にあたり、本規約掲載画面の「同意する」ボタンをクリックすることにより本規約の内容を承諾しているものとみなされます。
              </li>
              <li>
                本サービスを提供するシステムは株式会社ネットラーニングにより運営されているため、以下に定める当社の行為、権利・義務の行使については、同社に代行・代理させることがあります。
              </li>
              <li>
                本規約と「eラーニングシステム利用規約」に重複して定められた事項については、「eラーニングシステム利用規約」が優先するものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第2条（受講者への通知）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、受講者に対しインターネット上または当社が適当と判断する方法により、随時本規約に関わる必要な事項を通知、または照会できる状態におきます。
              </li>
              <li>
                前項の通知は、当社が前項の規定により行った時点で効力を発するものとし、同時に当該通知が、この規約の一部となることがあります。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第3条（規約の変更）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は受講者の了承を得ることなく本規約を変更することがあります。この場合、本サービスの利用条件は変更後の規約によります。
              </li>
              <li>
                変更後の規約は、前条の規定により受講者へインターネット上、Eメールまたは当社が適当と判断する方法で通知するものとし、別段の受講者からの異議申し立てがない限り通知日をもって受講者が同通知の内容に同意したものとみなします。
              </li>
              <li>
                受講者から利用規約の内容に対して異議申し立てがあった場合は、株式会社ネットラーニング社の「eラーニングシステム利用規約」に準ずるものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第4条（利用の承認と不承認）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、別途定める方法にて本サービスの利用申込を受け付け、必要な審査・手続等を経た後に承認します。
              </li>
              <li>
                当社は、本サービスの利用申込者が以下のいずれかに該当する場合、その者の利用を承認しないことがあります。
                <ol>
                  <li>
                    利用申込者の健康状態に異常がある、もしくは当該コースを受講する上で健康上の支障がある場合
                  </li>
                  <li>
                    申込時の健康調査票のチェック欄に印が入り、その後の医師の診断で受講に適さないと診断された場合。
                  </li>
                  <li>利用申込者が実在しない場合。</li>
                  <li>利用申込者が既に受講者であり、二重登録となる場合。</li>
                  <li>利用申込の際の申告事項に、虚偽の記載、誤記入または記入漏れがあった場合。</li>
                  <li>
                    用申込者が未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、利用申込の手続が成年後見人によって行われておらず、または利用申込の際に法定代理人、保佐人もしくは補助人の同意を得ていなかった場合。
                  </li>
                  <li>
                    利用申込者が暴力団その他の反社会的勢力に加入している、もしくはこれらの者と取引を行っている場合。
                  </li>
                  <li>その他利用申込者を当社が不適当と認めた場合。</li>
                </ol>
              </li>
              <li>
                前項により当社が利用の不承認を決定するまでの間に当該利用申込者が本サービスを利用したことにより発生する利用料は、当該利用申込者の負担とし当該利用申込者は当該債務を履行するものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">
            第5条（ＩＤおよびパスワードの発行と契約）
          </h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、利用申込者に対する本サービスの利用を承認した場合、受講者に対しＩＤおよびパスワードを発行します。
              </li>
              <li>
                ＩＤおよびパスワードの発行をもって、当社と受講者間の本サービスに係わる契約（以下「本契約」という）は有効に成立したものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第6条（譲渡禁止等）</h4>
          <div class="page-content__article-section-body">
            受講者は、受講者として有する権利を第三者に譲渡、売買、名義変更、質権の設定その他の担保に供する等の行為はできないものとします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第7条（変更の届出）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、当社への届出内容に変更があった場合、速やかに当社が指定する方法で変更の届出をするものとします。
              </li>
              <li>
                前項の届出がなかったことにより受講者が不利益を被った場合、当社は一切その責任を負いません。
              </li>
              <li>
                受講者の姓、生年月日等基本的に変更の必要がない項目に関しては、婚姻による姓の変更等当社が認めた場合を除いて原則的に変更できないものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第8条（設備等）</h4>
          <div class="page-content__article-section-body">
            受講者は、本サービスを利用するために必要な通信機器、ソフトウェア、その他これらに付随して必要となる全ての設備を自己の費用と責任において準備し、本サービスが利用可能な状態に置くものとします。また、自己の費用と責任でインターネットにより本サービスに接続するものとします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第9条（サービスの利用料）</h4>
          <div class="page-content__article-section-body">
            受講者は、本サービスを利用するにあたり当社が別途定める本サービスの利用料を本サービスの利用開始前に支払うものとします。その支払方法は当社が承認する支払方法によるものとします。ただし、法人による利用申込の場合、利用料の支払を利用申込法人がおこなうことを認める場合があります。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第10条（サービス利用開始の許諾）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、受講者に対するＩＤおよびパスワードの発行をもって本サービスの利用を当該受講者に対し許諾するものとし、当該受講者は本サービスを本規約に定める条件に従って利用することができるものとします。
              </li>
              <li>
                当社は、受講者に対するＩＤおよびパスワードの発行ならびに本サービスの利用許諾をＥメールまたは当社が適当と判断する方法により通知します。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第11条（サービスの利用中止）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、本サービスの利用中止を希望する場合、当社が指定する方法により届け出るものとします。
              </li>
              <li>
                当社は、当社が定める本サービスの利用開始日から起算して8日以内に受講者からの本サービスの利用中止の届出を受理し、かつ当該受講者による本サービスの利用が１つの章を終えていない場合、当該受講者が当社に支払った本サービスの利用料を返還するものとします。但し、利用料の返還に必要となる振り込み手数料や、その他の費用は全て当該受講者の負担とします。この場合であっても、受講者が利用した本サービスについては本規約の適用があるものとします。ただし、法人による利用申込の場合は、サービスの利用中止はできません。
              </li>
              <li>
                当社は、前項に定める場合を除き受講者から受領した利用料、その他の債務の払い戻し等は一切行いません。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第12条（受講期限）</h4>
          <div class="page-content__article-section-body">
            受講者は、本サービスの利用開始日の翌日から6ヵ月を経過するまでの間、本サービスを利用することができます。この受講期限は、いかなる理由があっても延長することはできないものとします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第13条（延滞利息）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、支払期日を過ぎても利用料を支払わない場合、支払期日の翌日から支払日の前日までの日数に年１４．５％の割合で計算される金額を延滞利息として支払うものとします。
              </li>
              <li>前項支払に必要な振り込み手数料その他の費用は全て当該受講者の負担とします。</li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第14条（使用範囲）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、本サービスの利用を通じて知りえた一切の情報を（以下「コンテンツ」という）を第三者に開示してならないものとします。
              </li>
              <li>
                受講者は、第三者に対し本サービスの再使用権の設定、頒布、販売、譲渡、貸与を行ってはならないものとします。
              </li>
              <li>受講者は、前各項に違反する行為を第三者にさせてはならないものとします。</li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第15条（ＩＤおよびパスワードの抹消）</h4>
          <div class="page-content__article-section-body">
            当社は、利用申込の承認後であっても当社が承認した受講者が本規約の規定に違反した場合、Eメールもしくは当社が適当と認める方法により当該受講者に通知することにより、利用申込の承諾を取り消し、発行済のIDおよびパスワードを抹消することができます。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">
            第16条（ＩＤおよびパスワードの管理責任）
          </h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、自己のＩＤおよびパスワードの使用および管理について全ての責任を負うものとします。
              </li>
              <li>
                当社は、受講者のＩＤおよびパスワードが第三者に使用されたことによって当該受講者が被る損害について、当該受講者の故意過失の有無にかかわらず一切責任を負いません。
              </li>
              <li>
                受講者は、自己の設定したパスワードを失念した場合、またはＩＤおよびパスワードが盗まれたり、第三者に使用されたりしていることを知った場合には、直ちに当社に申し出るものとし当社の指示に従うものとします。
              </li>
              <li>
                当該ＩＤおよびパスワードによりなされた本サービスの利用は、当該受講者によりなされたものとみなし、当該受講者は利用料その他の債務の一切を負担するものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第17条（自己責任の原則）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者は、自己のＩＤおよびパスワードにより本サービスを利用してなされた一切の行為およびその結果について当該行為を自己がしたか否かを問わず責任を負います。
              </li>
              <li>
                受講者は、本サービスの利用に伴い第三者からの問合せ、クレーム等が通知された場合は自己の責任と費用をもって処理解決するものとします。
              </li>
              <li>
                受講者は、第三者の行為に対する要望、疑問もしくはクレームがある場合は、当該第三者に対し直接その旨を通知するものとし、その結果については自己の責任と費用をもって処理解決するものとします。
              </li>
              <li>
                受講者は、本サービスの利用により当社または第三者に対して損害を与えた場合、自己の責任と費用をもって損害を賠償するものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第18条（その他の禁止事項）</h4>
          <div class="page-content__article-section-body">
            受講者は、本サービス上で以下の行為を行わないものとします。
            <ol>
              <li>ＩＤおよびパスワードを不正に使用する行為。</li>
              <li>
                本サービスを通じて、または本サービスに関連してコンピュータウィルス等の有害なプログラムを使用もしくは提供する行為。
              </li>
              <li>
                コンテンツの全部または一部の修正およびコンテンツを基にした派生的制作物を作成する行為。
              </li>
              <li>当社の商標権等の知的財産権を侵害する行為、または侵害するおそれのある行為。</li>
              <li>
                本サービスを通じて入手したデータ、情報、文章、ソフトウェア等に関し、著作権法で認められた私的利用の範囲を超え複製、配布、販売、出版等を行う行為。
              </li>
              <li>
                第三者の財産、プライバシーもしくは肖像権を侵害する行為、または侵害するおそれのある行為。
              </li>
              <li>第三者を差別もしくは誹謗中傷しまたは第三者の名誉もしくは信用を毀損する行為。</li>
              <li>犯罪的行為または犯罪的行為に結び付く行為、もしくはそのおそれのある行為。</li>
              <li>性風俗、宗教、政治に関する活動。</li>
              <li>
                上記各号の他、法令、本規約もしくは公序良俗に違反（売春、暴力、残虐等）する行為、本サービスの運営を妨害する行為、当社の信用を毀損、もしくは財産を侵害する行為、または当社に不利益を与える行為。
              </li>
              <li>暴力団もしくはその他反社会的勢力の活動に関係する行為。</li>
              <li>上記各号のいずれかに該当する行為を助長する行為。</li>
              <li>その他、当社が不適切と認める行為。</li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第19条（利用資格の中断・取り消し）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                受講者が前条の項目に該当する場合、当社は事前に通知することなく直ちに当該受講者の本サービスの利用資格を中断または将来に向かって取り消すこととします。なお、利用資格が取り消された場合においても、当該受講者に本規約に基づく債務が存在する場合は、当該受講者は当該債務の全額を当社に対して負担するものとします。
              </li>
              <li>
                当社は、前項の措置を取ったことにより当該受講者が本サービスを利用できず、これにより損害が発生したとしてもいかなる責任も負わないものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第20条（損害賠償）</h4>
          <div class="page-content__article-section-body">
            受講者は、本規約および法令の定めに違反したことにより当社を含む第三者に損害を及ぼした場合、当該損害を賠償する責任を負うものとし当社を含む第三者を免責しなければならないものとします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第21条（個人情報）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、以下の情報を個人情報として取扱います。
                <ol>
                  <li>
                    氏名、住所、生年月日、Ｅメールアドレス等、当社のサービスを利用するにあたり必要となる登録情報。
                  </li>
                  <li>健康調査票にて取得した身体の健康状態に係る情報。</li>
                  <li>利用サービスの内容、およびその料金の請求等の取引に関する情報。</li>
                  <li>本サービスを利用するために当社が付与したＩＤおよびパスワード。</li>
                  <li>
                    本サービスを利用する過程で行われた発言、質問、解答、アンケートへの回答、および質問や解答に対する返答などの情報。
                  </li>
                  <li>
                    本サービスを利用する過程で記録されたログイン、ログアウト等の情報、および学習の進捗状況、学習成績等の情報。
                  </li>
                  <li>
                    その他、電子メール、電話、ＦＡＸ、手紙等により、当社との間でなされた問い合わせや申し込み等の情報、およびそれに対する当社からの回答や対応等の情報。
                  </li>
                </ol>
              </li>
              <li>
                利用申込者が当該コース修了後、コースの続き（海洋実習などの実技講習）を受けるダイブセンター、メンバーに対し個人情報を開示する場合があります。
              </li>
              <li>
                当社は、本条第１項１～7号、他の指導機関での認定情報以外の個人情報の提供は受けないものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第22条（個人情報の使用）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、前条に規定する個人情報を以下の目的のために使用することができるものとします。
                <ol>
                  <li>当社のサービスを提供するため。</li>
                  <li>
                    サービスの利用料金の請求等、当社のサービス提供に付帯する業務を遂行するため。
                  </li>
                  <li>当社のサービス利用動向の調査および分析のため。</li>
                  <li>当社の新しいサービスの研究または開発をするため。</li>
                  <li>利用者が本規約に違反していると考えられるときに調査、対応するため。</li>
                </ol>
              </li>
              <li>
                当社は、以下の項目に該当する場合を除き、前項で規定される個人情報を第三者に開示しないものとします。
                <ol>
                  <li>受講者が個人情報の開示について別途同意している場合。</li>
                  <li>
                    前項の利用目的の達成のために、第三者と共同または委託により情報を取扱う場合。
                  </li>
                  <li>
                    営業譲渡、分社等により営業資産の一部として、個人情報を第三者に引き継ぐ場合。
                  </li>
                  <li>
                    個人情報を特定の第三者との間で相互に利用する場合であって、あらかじめその利用目的および特定の第三者についてあらかじめ通知され、または公表されている場合。
                  </li>
                  <li>
                    前項第２号及び第５号に該当する事項その他当社と利用者との法律問題につき、弁護士に相談又は対応を依頼する場合
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第23条（サービス条件）</h4>
          <div class="page-content__article-section-body">
            当社は、本サービスの運営に関し本サービスの利用を監視し、必要と認める場合、自己の裁量において本サービスへのアクセスを制限することができます。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第24条（サービス内容等の変更）</h4>
          <div class="page-content__article-section-body">
            当社は、受講者への事前の通知なくして本サービスの内容、名称を変更することがあります。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第25条（サービスの一時的な中断）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>
                当社は、以下のいずれかの事由が生じた場合には、受講者に事前に通知することなく一時的に本サービスを中断することがあります。
                <ol>
                  <li>
                    インターネット上に不具合が発生し、インターネットの利用ができなくなった場合。
                  </li>
                  <li>
                    当社が本サービスにおけるインターネット接続を委託している、インターネット接続サービス事業者が保有する通信設備等に不具合が発生し、インターネットの利用ができなくなった場合。
                  </li>
                  <li>本サービス用設備等の保守を定期的または緊急に行う場合。</li>
                  <li>火災、停電等により本サービスの提供ができなくなった場合。</li>
                  <li>
                    地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合。
                  </li>
                  <li>
                    戦争、動乱、暴動、騒乱、労働争議等により本サービスの提供ができなくなった場合。
                  </li>
                  <li>
                    その他、運用上または技術上当社が本サービスの一時的な中断が必要と判断した場合。
                  </li>
                  <li>
                    株式会社ネットラーニングが何らかの理由で、本サービスの提供が困難となった場合。
                  </li>
                </ol>
              </li>
              <li>
                当社は、前項各号のいずれかまたはその他の事由により本サービスの提供の遅延または中断等が発生したとしても、これに起因する受講者または第三者が被った損害について一切責任を負わないものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第26条（サービス提供の中止）</h4>
          <div class="page-content__article-section-body">
            当社は、事前通知をした上で本サービスの全部または一部の提供を中止することがあります。但し、事前通知について緊急又はやむを得ない場合はこの限りではありません。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第27条（免責）</h4>
          <div class="page-content__article-section-body">
            <ol>
              <li>本サービスの内容は、当社がその時点で提供可能なものとします。</li>
              <li>
                当社は、本サービスの利用により発生した受講者の損害（第三者との間で生じたトラブルに起因する損害を含みます。）、または第三者の損害に対しいかなる責任も負わないものとし損害賠償義務を一切負わないものとします。
              </li>
              <li>
                当社は、本サービスへのアクセス制限、本サービスの中止・中断などの発生により、本サービスを利用できなかったことにより発生した受講者または第三者が被ったいかなる損害について理由を問わずいかなる責任も負わないものとし、損害賠償義務を一切負わないものとします。
              </li>
            </ol>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第28条（協議）</h4>
          <div class="page-content__article-section-body">
            本サービスに関連して受講者と当社との間で紛争が生じた場合には、当該当事者がともに誠意をもって協議するものとします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第29条（専属的合意管轄裁判所）</h4>
          <div class="page-content__article-section-body">
            受講者と当社の間で訴訟の必要が生じた場合、東京地方裁判所を受講者と当社の第一審の専属的合意管轄裁判所とします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">第30条（準拠法）</h4>
          <div class="page-content__article-section-body">
            本規約に関する準拠法は、日本法とします。
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">附　則</h4>
          <div class="page-content__article-section-body">
            この規約は2022年3月1日から施行します。
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__consent-check-wrapper">
        <label class="page-footer__consent-check">
          <input
            type="checkbox"
            @change="agreeTerms"
            class="page-footer__consent-check--input"
          /><span class="page-footer__consent-check--dummy-input"></span
          ><span class="page-footer__consent-check-LabelText">利用規約に同意する</span></label
        >
      </div>
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/about" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link v-show="!isButtonDisabled" to="/course-list" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              受講コース一覧画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isButtonDisabled: true,
    };
  },
  methods: {
    /**
     *
     */
    agreeTerms: function () {
      this.isButtonDisabled = !this.isButtonDisabled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';

/*
チェックボックス
https://eclair.blog/examples-of-checkbox/
*/

.page-footer__consent-check {
  width: 230px;
  margin: 0 auto 1rem auto;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.page-footer__consent-check--input {
  margin: 0;
  width: 0;
  opacity: 0;
}
.page-footer__consent-check:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}
.page-footer__consent-check:hover > .page-footer__consent-check--dummy-input {
  transform: scale(1.1);
}
.page-footer__consent-check--input:focus + .page-footer__consent-check--dummy-input {
  transform: scale(1.1);
}
.page-footer__consent-check--input:checked + .page-footer__consent-check--dummy-input {
  background: rgba(107, 26, 250, 1);
}
.page-footer__consent-check--input:checked + .page-footer__consent-check--dummy-input::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 35%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-135deg);
  transform-origin: 2px 2px;
  background: #ffffff;
}
.page-footer__consent-check--input:checked + .page-footer__consent-check--dummy-input::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 4px;
  border-radius: 2px;
  transform: translate(-6px, 5px) rotateZ(-45deg);
  transform-origin: 2px 2px;
  background: #ffffff;
}
.page-footer__consent-check--dummy-input {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 32px;
  height: 32px;
  border: solid 2px transparent;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  transition: all 0.15s linear;
}
.page-footer__consent-check-LabelText {
  margin-left: 12px;
  display: block;
  font-size: 18px;
  font-weight: bold;
}
</style>
